import { Trans } from '@lingui/react/macro';

import { Switch } from '@/components/Form';
import type { SolQueryFilterOperator } from '@/components/InstantSearch';
import { Text } from '@/components/typography';

type Props = {
  operator?: SolQueryFilterOperator;
  onChange: (operator: SolQueryFilterOperator) => void;
};

const IncludeExcludeToggle = ({ operator, onChange }: Props) => {
  if (operator && operator !== 'in' && operator !== 'notIn') {
    throw new Error('Include/Exclude toggle can only be used with in/notIn operators');
  }

  const handleChange = (checked: boolean) => {
    onChange(checked ? 'notIn' : 'in');
  };

  return (
    <div className="absolute top-0 right-0 flex items-center gap-2">
      <Switch checked={operator === 'notIn'} onCheckedChange={handleChange} />
      <Text variant="caption1">
        <Trans>Exclude</Trans>
      </Text>
    </div>
  );
};
export default IncludeExcludeToggle;
